module.exports = __webpack_public_path__ + "b3fa0a070ca4d142d84385abe94a6585.glb";